var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreEqual = function SvgMoreEqual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "more_equal_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#more_equal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.096 4.974a1.5 1.5 0 0 0 .878 1.93L13.228 10l-8.254 3.096a1.5 1.5 0 0 0 1.053 2.809l12-4.5a1.5 1.5 0 0 0 0-2.81l-12-4.5a1.5 1.5 0 0 0-1.931.879M18.905 14.474a1.5 1.5 0 0 0-1.931-.878l-12 4.5a1.5 1.5 0 0 0 1.053 2.809l12-4.5a1.5 1.5 0 0 0 .878-1.931"
  }))));
};
export default SvgMoreEqual;